/**
 * Blog Dashboard Page
 *
 * Placeholder component — the actual Ghost iframe is rendered
 * by PersistentGhost in MainLayout to keep it mounted across navigation.
 *
 * This component exists only to:
 * 1. Satisfy the router (so /blog is a valid route)
 * 2. Provide a fallback if PersistentGhost hasn't mounted yet
 *
 * Mirrors InboxPage pattern exactly.
 */

export function BlogDashboardPage() {
  // PersistentGhost in MainLayout handles the actual iframe rendering
  return null;
}
